import React from 'react';
import { DynamicWaiverSignatureCanvas } from './DynamicWaiverSignatureCanvas';
import { DynamicWaiverSignatureImage } from './DynamicWaiverSignatureImage';

export const DynamicWaiverSignature = ({ edit, ...props }) =>
  edit ? <DynamicWaiverSignatureCanvas {...props} /> : <DynamicWaiverSignatureImage {...props} />;
